import { Button, Grid, Typography, MenuItem } from "@mui/material";
import { all } from "axios";
import React, { useEffect, useState } from "react";
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";
import CustomTextFieldComp from "../../newComponent/customTextFieldComp";
import CustomAutocompleteComp from "../../newComponent/AutocompleteComp";
import { Controller, useForm } from "react-hook-form";
import {
  emailWithRequiredPattern,
  namePattern,
  nameWithRequiredPattern,
  validateMobile,
} from "../../../utils/formatTime";

export default function AddSvo({
  onClose,
  selectedRowData,
  setSelectedRowData,
}) {
  console.log("selectedRowData", selectedRowData);

  const userId = localStorage.getItem("userId");
  const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const [firstName, setFirstName] = useState(
    selectedRowData?.enq_personal_details_id?.first_name || null
  );
  const [lastName, setLastName] = useState(
    selectedRowData?.enq_personal_details_id?.last_name || null
  );
  const [email, setEmail] = useState(selectedRowData?.email || null);
  const [isdCode, setIsdCode] = useState(
    selectedRowData?.mobile_country_code || 91
  );
  const [mobile, setMobile] = useState(selectedRowData?.mobile || null);
  const [selectedCampaign, setSelectedCampaign] = useState("Virtual Office");
  const [branchList, setBranchList] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [serviceList, setServiceList] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [subserviceList, setSubserviceList] = useState([]);
  const [selectedsubService, setSelectedSubService] = useState(null);
  const [CountryList, setCountryList] = useState([]);

  const phoneRegex = /^[1-9][0-9]{9}$/;
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

  const [targetCountry, setTargetcountry] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const [leadsourceTypelist, setLeadSourceTypelist] = useState([]);
  const [leadsourceType, setLeadSourceType] = useState(null);
  const [subleadSourceTypeList, setSubleadSourceTypeList] = useState([]);
  const [subleadSourceType, setSubleadSourceType] = useState(null);
  const [userList, setUserList] = useState([]);
  const [assignTo, setAssignTo] = useState(null);
 const [referenceByList, setReferenceByList] = useState([]);
  const [referenceBy, setReferenceBy] = useState(null);
    const [showOtherField, setShowOtherField] = useState(false);
        const [referenceEmployee, setReferenceEmployee] = useState(null);
           const [referenceEmployeeList, setReferenceEmployeeList] =useState([])

  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}country`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = [...data].sort(
            (a, b) => a.phone_code - b.phone_code
          );
          const uniqueArray = sortedData.filter(
            (obj, index, self) =>
              index === self.findIndex((t) => t.phone_code === obj.phone_code)
          );

          setCountryList(uniqueArray);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}service`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setServiceList(sortedData);
          const filteredService = data.find(
            (i) => i.id === selectedRowData?.service_id
          );

          setSelectedService(filteredService || null);
          setValue(filteredService?.id || null)
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  console.log("selectedService ", selectedService);

  // useEffect(() => {
  //   if (serviceList.length > 0) {
  //     const defaultService = serviceList.find((i) => i.id === 1);
  //     const selectedService = serviceList.find((i) => i.id === selectedRowData?.service_id);

  //     setSelectedService(selectedService ?? defaultService);
  //   }

  //   if (subserviceList.length > 0) {
  //     const selectedsubService = subserviceList.find((i) => i.id === selectedRowData?.sub_service_id);

  //     setSelectedSubService(selectedsubService || null);
  //   }
  // }, [ selectedRowData]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subservice`);
        if (response.ok) {
          const data = await response.json();
          const subServiceData = data.filter(
            (i) => i.service_id === selectedService?.id
          );
          const sortedData = subServiceData.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setSubserviceList(sortedData);
          const selectedSubservice = data.find(
            (i) => i.id === selectedRowData?.sub_service_id
          );
          setSelectedSubService(selectedSubservice || null);
          setValue("sub_service_id" ,selectedSubservice || null )
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [selectedService, selectedRowData]);
  console.log();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}targetcountries`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setTargetcountry(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}branch`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setBranchList(sortedData);
          const filteredBranch = data.find(
            (branch) =>
              branch.id ===
              selectedRowData?.enq_personal_details_id?.nearest_branch_id
          );
          setSelectedBranch(filteredBranch);
          setValue('nearest_branch_id', filteredBranch?.id || null  )
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}leadsource`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          const filterdata = sortedData.filter((item) => item.is_active === 1);
          setLeadSourceTypelist(filterdata);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subleadsource`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          const filterdSubleadSource =sortedData.filter((i)=>i?.lead_source_type_id===leadsourceType?.id)
          setSubleadSourceTypeList(filterdSubleadSource);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [leadsourceType]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}route2.0/getadvisors/${userId}`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setUserList(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleCampaignChange = (e) => {
    setSelectedCampaign(e.target.value);
  };
  const handleServiceChange = (value) => {
    setSelectedSubService(null);
    setSelectedService(value);

    setSelectedRowData({ ...selectedRowData, sub_service_id: null });
    setValue("service_id", value?.id);
  };

  const handleSubServiceChange = (event, value) => {
    setSelectedSubService(value);
    setValue("sub_service_id", value?.id);
  };

  const handlecountryChange = (value) => {
    setSelectedCountry(value);
    setValue("target_country_id", value);
  };

  const handlebranchChange = (value) => {
    setSelectedBranch(value);
    setValue("nearest_branch_id", value?.id);
  };

  const handleLeadsourceChange = (value) => {
    setLeadSourceType(value);
    setValue("lead_source_type_id", value);
  };

  const handleSubLeadsourceChange = (value) => {
    setSubleadSourceType(value);
    setValue("sub_lead_source_type_id", value);
  };

  const handleAssignToChange = (event, value) => {
    setAssignTo(value);
    setValue("assign_to", value);
  };
  const {
    control,
    formState: { errors },
    watch,
    setValue,
    setError,
    handleSubmit,
  } = useForm();


   useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await fetch(`${API_ENDPOINT}referencewalkin`);
          if (response.ok) {
            const data = await response.json();
            console.log("data", data);
            const sortedData = data.sort(
              (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
            );
  
            setReferenceByList(sortedData);
          } else {
            throw new Error(`Request failed with status: ${response.status}`);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
  
      fetchData();
    }, []);
  
     useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await fetch(`${API_ENDPOINT}route/getalluser`);
            if (response.ok) {
              const data = await response.json();
    
              setReferenceEmployeeList(data);
          
            } else {
              throw new Error(`Request failed with status: ${response.status}`);
            }
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        };
    
        fetchData();
      }, []);
  
   const handleReferenceChange = (event, value) => {
    if (value && value.name === "Other") {
      setShowOtherField(true); // Show the additional text field
      setReferenceBy(value); // Clear the selection
     
      setValue("reference_marketing_id", value?.id || null);
      // Reset the controlled value
    } else {
      setShowOtherField(false); // Hide the additional text field
      setReferenceBy(value);
      setValue("reference_marketing_id", value?.id || null);
      setValue("reference_employee_id", null);
      
    }
  };


    const handleReferenceEmployeeChange = (event, value) => {
    setReferenceEmployee(value);
    setValue("reference_employee_id", value?.id);
  };

  const onSubmit = async (data) => {
if (referenceBy?.id === "Other") {
      data.reference_marketing_id = null;
    }

    try {
      const requestData = {
        ...data,

        nearest_branch_id: selectedBranch?.branch_name || null,
        country_id: "India",
        target_country_id: selectedCountry?.country_name || null,
        service_id: selectedService?.service_name || null,
        sub_service_id: selectedsubService?.name || null,
        lead_source_type_id: leadsourceType?.name || null,
        sub_lead_source_type_id: subleadSourceType?.source_type || null,
        campaign_id: "Virtual Office",
        lead_entry_point: "STM SVO Enquiry",
        user_id: parseInt(userId),
        assign_to: assignTo?.user_id || null,
        raw_svo_enquiry_id: selectedRowData?.id || null,
      };
      const response = await fetch(`${API_ENDPOINT}addsvoenquiry`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      if (response.ok) {
        showSnackbar("Enquiry added Successfully.");

        // setTimeout(() => {
        //   window.location.reload();
        // }, 1500);
      } else if (response.status === 400) {
          const responseData = await response.json();
          showSnackbar(responseData.message || "Validation error", "error");
        } else {
        showSnackbar("server error", "error");
      }
    } catch (error) {
      console.error("Server Error:", error);
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Typography variant="h6">
            First Name
            <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span>
          </Typography>
          <Controller
            name="first_name"
            control={control}
            rules={nameWithRequiredPattern}
            defaultValue={ selectedRowData?.enq_personal_details_id?.first_name || null}
            render={({ field }) => (
              <CustomTextFieldComp
                size="normal"
                {...field}
                fullWidth
                //value={studentInfo.first_name || ''}
                // onChange={(e) => setStudentInfo({ ...studentInfo, first_name: e.target.value })}
                InputProps={{
                  style: { borderRadius: "10px" },
                }}
                error={Boolean(errors.first_name)}
                helperText={errors.first_name && errors?.first_name?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={6} md={6}>
          <Typography variant="h6">Last Name</Typography>
          <Controller
            name="last_name"
            control={control}
            //rules={{ required: true }}

            rules={namePattern}
            render={({ field }) => (
              <CustomTextFieldComp
                {...field}
                size="normal"
                fullWidth
                //value={studentInfo.last_name || ''}
                //onChange={(e) => setStudentInfo({ ...studentInfo, last_name: e.target.value })}
                InputProps={{
                  style: { borderRadius: "10px" },
                }}
                error={!!errors.last_name}
                helperText={errors.last_name && errors.last_name?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={6} md={6}>
          <Typography variant="h6">
            Email
            <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span>
          </Typography>
          <Controller
            name="email"
            control={control}
            rules={emailWithRequiredPattern}
            defaultValue={selectedRowData?.email || null}
            render={({ field }) => (
              <CustomTextFieldComp
                {...field}
                size="normal"
                // label="Email"
                InputProps={{
                  style: { borderRadius: "10px" },
                }}
                variant="outlined"
                error={!!errors.email}
                helperText={errors.email && errors.email.message}
                fullWidth
                //value={studentInfo.email || ''}
                // onChange={(e) => setStudentInfo({ ...studentInfo, email: e.target.value })}
              />
            )}
          ></Controller>
        </Grid>

        <Grid item xs={12} md={6} lg={6} sm={6} container>
          <Grid item xs={4} md={4} lg={3.5}>
            <Typography variant="h6">
              ISD code
              <span
                style={{
                  color: "red",
                  position: "absolute",
                  marginLeft: "4px",
                  fontSize: "1em",
                }}
              >
                *
              </span>
            </Typography>
            <Controller
              name="mobile_country_code"
              control={control}
              rules={{ required: "Country code is required" }}
              defaultValue={selectedRowData?.mobile_country_code || 91}
              render={({ field }) => (
                <CustomTextFieldComp
                  select
                  size="normal"
                  {...field}
                  InputProps={{
                    style: { borderRadius: "10px" },
                  }}
                  fullWidth
                  error={Boolean(errors.mobile_country_code)}
                  helperText={
                    errors.mobile_country_code &&
                    errors.mobile_country_code?.message
                  }
                >
                  {CountryList.map((country) => (
                    <MenuItem
                      key={country.phone_code}
                      value={country.phone_code}
                    >
                      {country.phone_code}
                    </MenuItem>
                  ))}
                </CustomTextFieldComp>
              )}
            />
          </Grid>

          <Grid item xs={8} md={8} lg={8.5}>
            <Typography variant="h6">
              Mobile Number
              <span
                style={{
                  color: "red",
                  position: "absolute",
                  marginLeft: "4px",
                  fontSize: "1em",
                }}
              >
                *
              </span>
            </Typography>
            <Controller
              name="mobile"
              control={control}
              defaultValue={selectedRowData?.mobile || null}
              rules={{
                required: "Contact number is required",
                validate: (value) => {
                  const isdCode = watch("mobile_country_code");
                  const error = validateMobile(isdCode, value);
                  return error || true;
                },
              }}
              render={({ field }) => (
                <CustomTextFieldComp
                  size="normal"
                  {...field}
                  InputProps={{
                    style: { borderRadius: "10px" },
                  }}
                  error={!!errors.mobile}
                  helperText={errors.mobile && errors.mobile.message}
                  fullWidth
                  //value={studentInfo.mobile || ''}
                  //onChange={(e) => setStudentInfo({ ...studentInfo, mobile: e.target.value })}
                />
              )}
            ></Controller>
          </Grid>
        </Grid>

        <Grid item xs={12} md={6} lg={6} sm={6}>
          <Typography variant="h6">
            Campaign
            <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span>
          </Typography>
          <Controller
            name="campaign_id"
            control={control}
            render={({ field }) => (
              <CustomTextFieldComp
                {...field}
                size="normal"
                onChange={handleCampaignChange}
                value={selectedCampaign}
                InputProps={{
                  style: { borderRadius: "10px" },
                  readOnly: true,
                }}
                fullWidth
              />
            )}
          />

          {errors.selectedCampaign && (
            <Typography color="error" variant="caption">
              Campaign Name is required
            </Typography>
          )}
        </Grid>

        <Grid item xs={12} md={6} lg={6}>
          <Typography variant="h6">
            Nearest Branch
            <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span>
          </Typography>

          <Controller
            name="nearest_branch_id"
            control={control}
            rules={{ required: "Field is required" }}
            render={({ field }) => (
              <CustomAutocompleteComp
                {...field}
                disablePortal
                value={selectedBranch}
                options={branchList}
                onChange={(event, value) => {
                  console.log(value);

                  handlebranchChange(value); // Passing only the value
                }}
                getOptionLabel={(option) => option.branch_name}
                error={!!errors.nearest_branch_id}
                helperText={
                  errors.nearest_branch_id && errors.nearest_branch_id?.message
                }
              />
            )}
          />
        </Grid>

        <Grid item xs={12} md={6} lg={6}>
          <Typography variant="h6">
            Service
            <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span>
          </Typography>
          <Controller
            name="service_id"
            control={control}
            rules={{ required: "Field is required" }}
            render={({ field }) => (
              <CustomAutocompleteComp
                {...field}
                disablePortal
                value={selectedService}
                onChange={(event, value) => {
                  handleServiceChange(value); // Passing only the value
                }}
                options={serviceList}
                getOptionLabel={(option) => option.service_name}
                renderInput={(params) => (
                  <CustomTextFieldComp
                    {...params}
                    variant="outlined"
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      style: { borderRadius: "10px" },
                    }}
                  />
                )}
                error={!!errors.service_id}
                helperText={errors.service_id && errors.service_id?.message}
              />
            )}
          />
        </Grid>

        {selectedService !== null && (
          <Grid item xs={12} md={6} lg={6}>
            <Typography variant="h6">
              Sub Service
              <span
                style={{
                  color: "red",
                  position: "absolute",
                  marginLeft: "4px",
                  fontSize: "1em",
                }}
              >
                *
              </span>
            </Typography>
            <Controller
              name="sub_service_id"
              control={control}
              rules={{ required: "Field is required" }}
              render={({ field }) => (
                <CustomAutocompleteComp
                  {...field}
                  disablePortal
                  value={selectedsubService}
                  onChange={
                    handleSubServiceChange // Passing only the value
                  }
                  options={subserviceList}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <CustomTextFieldComp
                      {...params}
                      variant="outlined"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        style: { borderRadius: "10px" },
                      }}
                    />
                  )}
                  error={!!errors.sub_service_id}
                  helperText={
                    errors.sub_service_id && errors.sub_service_id?.message
                  }
                />
              )}
            ></Controller>
          </Grid>
        )}

        <Grid item xs={12} md={6} lg={6}>
          <Typography variant="h6">
            First Country Of Interest
            <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span>
          </Typography>
          <Controller
            name="target_country_id"
            control={control}
            rules={{ required: "Field is required" }}
            render={({ field }) => (
              <CustomAutocompleteComp
                {...field}
                disablePortal
                onChange={(event, value) => {
                  handlecountryChange(value); // Passing only the value
                }}
                options={targetCountry}
                getOptionLabel={(option) => option.country_name}
                error={!!errors.target_country_id}
                helperText={
                  errors.target_country_id && errors.target_country_id?.message
                }
                renderInput={(params) => (
                  <CustomTextFieldComp
                    {...params}
                    variant="outlined"
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      style: { borderRadius: "10px" },
                    }}
                  />
                )}
              />
            )}
          ></Controller>
        </Grid>

        <Grid item xs={12} md={6} lg={6}>
          <Typography variant="h6">
            Lead Source Type
            <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span>
          </Typography>
          <Controller
            name="lead_source_type_id"
            control={control}
            rules={{ required: "Field is required" }}
            render={({ field }) => (
              <CustomAutocompleteComp
                {...field}
                disablePortal
                onChange={(event, value) => {
                  handleLeadsourceChange(value); // Passing only the value
                }}
                options={leadsourceTypelist}
                getOptionLabel={(option) => option.name}
                error={!!errors.lead_source_type_id}
                helperText={
                  errors.lead_source_type_id &&
                  errors.lead_source_type_id?.message
                }
                renderInput={(params) => (
                  <CustomTextFieldComp
                    {...params}
                    variant="outlined"
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      style: { borderRadius: "10px" },
                    }}
                  />
                )}
                sx={{
                  "& .MuiCustomAutocompleteComp-listbox": {
                    maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                    width: 250,
                  },
                }}
              />
            )}
          ></Controller>
        </Grid>

{leadsourceType && (
        <Grid item xs={12} md={6} lg={6}>
          <Typography variant="h6">
            Sub Lead Source Type
            <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span>
          </Typography>

          <Controller
            name="sub_lead_source_type_id"
            control={control}
            rules={{ required: "Field is required" }}
            render={({ field }) => (
              <CustomAutocompleteComp
                {...field}
                disablePortal
                onChange={(event, value) => {
                  handleSubLeadsourceChange(value); // Passing only the value
                }}
                options={subleadSourceTypeList}
                getOptionLabel={(option) => option.source_type}
                error={!!errors.sub_lead_source_type_id}
                helperText={
                  errors.sub_lead_source_type_id &&
                  errors.sub_lead_source_type_id?.message
                }
                renderInput={(params) => (
                  <CustomTextFieldComp
                    {...params}
                    variant="outlined"
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      style: { borderRadius: "10px" },
                    }}
                  />
                )}
                sx={{
                  "& .MuiCustomAutocompleteComp-listbox": {
                    maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                    width: 250,
                  },
                }}
              />
            )}
          ></Controller>
          {errors.subleadSourceType && (
            <Typography color="error" variant="caption">
              Sub lead source type is required
            </Typography>
          )}
        </Grid>
         )}


           {/* Referece By  */}
                         {subleadSourceType?.source_type === "Reference" && (
                           <Grid item xs={12} md={6} lg={6}>
                             <Typography variant="h6">
                              Marketing Reference List
                              
                             </Typography>
                             <Controller
                               name="reference_marketing_id"
                               control={control}
                              //  rules={{ required: "Reference by is required" }}
                               render={({ field }) => (
                                 <CustomAutocompleteComp
                                 size="small"
                                   {...field}
                                   value={referenceBy}
                                   onChange={handleReferenceChange}
                                   options={[
                                     ...referenceByList,
                                     { id: "Other", name: "Other" },
                                   ]}
                                   getOptionLabel={(option) => option.name}
                                   
                                 />
                               )}
                             />
                             
                           </Grid>
                         )}
         
                         {showOtherField && (
                           <Grid item xs={12} md={6} lg={6}>
                             <Typography variant="h6">
                               Employee Reference List
                               <span
                                 style={{
                                   color: "red",
                                   position: "absolute",
                                   marginLeft: "4px",
                                   fontSize: "1em",
                                 }}
                               >
                                 *
                               </span>
                             </Typography>
                             <Controller
                               name="reference_employee_id"
                               control={control}
                               
                               render={({ field }) => (
                                 <CustomAutocompleteComp
                                   {...field}
                                     size="small"
                                   value={referenceEmployee}
                                   onChange={handleReferenceEmployeeChange}
                                   options={referenceEmployeeList}
                                   getOptionLabel={(option) => option.first_name}
                                  
                                 />
                               )}
                             />
                           </Grid>
                         )}

        <Grid item xs={12} md={6} lg={6}>
          <Typography variant="h6">
            Assign To
            <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span>
          </Typography>
          <Controller
            name="assign_to"
            control={control}
            rules={{ required: "Field is required" }}
            render={({ field }) => (
              <CustomAutocompleteComp
                {...field}
                disablePortal
                onChange={handleAssignToChange}
                options={userList}
                value={assignTo}
                getOptionLabel={(option) =>
                  `${option.first_name ? option.first_name : ""} ${
                    option.last_name ? option.last_name : ""
                  }`
                }
                error={!!errors.assign_to}
                helperText={errors.assign_to && errors.assign_to?.message}
                renderInput={(params) => (
                  <CustomTextFieldComp
                    {...params}
                    variant="outlined"
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      style: { borderRadius: "10px" },
                    }}
                  />
                )}
                sx={{
                  "& .MuiCustomAutocompleteComp-listbox": {
                    maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                    width: 250,
                  },
                }}
              />
            )}
          ></Controller>
        </Grid>
        <Grid item xs={12} lg={12} md={12} sm={12} textAlign="end">
          <Button
            color="secondary"
            variant="contained"
            style={{ borderRadius: "25px" }}
            onClick={handleSubmit(onSubmit)}
          >
            Submit
          </Button>
        </Grid>
      </Grid>
      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
